// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9ac742e2","734":"7acb0ff4","840":"3c76a5ef"}[chunkId] + ".chunk.js";
};